import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { PrivacySettingsDialog } from '../../privacy-settings/privacy-settings-dialog/privacy-settings-dialog.component';

@Component({
  selector: 'wd-privacy-policy-en',
  templateUrl: './privacy-policy-en.component.html',
  styleUrls: ['../privacy-policy.component.scss'],
})
export class PrivacyPolicyEnComponent implements OnInit {
  constructor(public dialog: MatDialog) {}

  ngOnInit(): void {}

  scrollToId(scrollId: string) {
    setTimeout(() => {
      const element = <HTMLElement>document.querySelector('#' + scrollId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  }

  openSettingsDialog() {
    this.dialog.open(PrivacySettingsDialog);
  }
}
